import { NOTIFICATION_ENTITY_TYPES } from '@components/CRM/Notifications/constants';
import { get } from 'lodash';

export const serializeNotification = notification => ({
  createdAt: get(notification, 'created_at'),
  entityId: String(get(notification, 'entity_id')),
  entityType: NOTIFICATION_ENTITY_TYPES[get(notification, 'entity_type')],
  id: String(get(notification, 'id')),
  kind: get(notification, 'kind'),
  managerId: String(get(notification, 'whodunnit')),
  readAt: get(notification, 'read_at'),
  summary: get(notification, 'summary'),
});

export const serializeNotifications = notifications =>
  notifications.map(serializeNotification);

export const serializeNotificationsMeta = meta => ({
  page: get(meta, 'page'),
  size: get(meta, 'size'),
  total: get(meta, 'total'),
  totalPages: get(meta, 'total_pages'),
  unreadCount: get(meta, 'unread_count'),
});
